export default __webpack_public_path__ + "static/media/finaid_bg_large.2724a4f4.jpg";